var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('main',[_c('RouterView',{staticClass:"router-view"})],1),_c('FooterCustom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }